/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getWebLoginConfigJanus} from '../api'

 export const useQueryGetWebLoginConfigJanus = createReactQueryHook('getWebLoginConfigJanus', getWebLoginConfigJanus)
